import { Navigate, useParams } from 'react-router-dom';
import { IndustryPreviewVisual } from '@/modules/marketing/components/industry-visuals';
import { MarketingDetailPage } from '@/modules/marketing/components/marketing-detail-page';
import { PLATFORM_FEATURES, PlatformPreviewVisual } from '@/modules/marketing/components/platform-visuals';
import { isMarketingOnlyDomain } from '@/modules/marketing/components/site-chrome';
import { PRICINGCRM_FEATURES } from '@/modules/marketing/components/pricingcrm-content';

export function PlatformDetailPage() {
    const { slug } = useParams<{ slug: string }>();

    if (isMarketingOnlyDomain()) {
        const feature = PRICINGCRM_FEATURES.slice(4).find((f) => f.slug === slug);
        if (!feature) return <Navigate to="/" replace />;

        return (
            <MarketingDetailPage
                backLabel="Data & Analysis"
                backHref="/#products"
                visual={<IndustryPreviewVisual icon={feature.icon} size="lg" />}
                content={{
                    eyebrow: 'Data & Analysis',
                    icon: feature.icon,
                    gradient: 'from-[#7f1d2e] to-[#e62b4a]',
                    title: feature.title,
                    tagline: feature.description,
                    description: feature.description,
                    bullets: [],
                }}
            />
        );
    }

    const feature = PLATFORM_FEATURES.find((f) => f.slug === slug);

    if (!feature) {
        return <Navigate to="/" replace />;
    }

    return (
        <MarketingDetailPage
            backLabel="Data & Analysis"
            backHref="/#products"
            visual={<PlatformPreviewVisual icon={feature.icon} size="lg" />}
            content={{
                eyebrow: 'Data & Analysis',
                icon: feature.icon,
                gradient: 'from-[#4c1d95] to-[#8b5cf6]',
                title: feature.title,
                tagline: feature.tagline,
                description: feature.description,
                bullets: feature.bullets,
            }}
        />
    );
}
